import React, { useEffect, useRef, useState } from "react";
import { X } from "react-feather";
import usePlacesAutocomplete from "use-places-autocomplete";
import classNames from "classnames";

export function LabeledPlacesAutocomplete({ title, help, ...props }) {
  return (
    <div>
      <label>
        {title ? <span className="mb-1 block text-[14px]">{title}</span> : null}
        <PlacesAutocomplete {...props} />
      </label>
      {help ? <p className="mt-1 text-sm text-gray-600">{help}</p> : null}
    </div>
  );
}

// TODO The select portion of this should preferrably use a
// well tested, small, accessible third party library with good
// styling options, something like headless ui or reach ui.
export function PlacesAutocomplete({
  className = "",
  placeholder = "Enter a location",
  defaultValue = "",
  onChange,
  ...props
}) {
  const {
    ready,
    suggestions: { status, data },
    value,
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      ...(props?.requestOptions || {}),
    },
  });

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      setValue(defaultValue, false);
    }

    if (defaultValue === "") {
      setValue("", false);
    }
  }, [defaultValue]);

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  const handleSelect = ({ description, place_id }) => {
    setValue(description, false);
    clearSuggestions();
    onChange({ description, place_id });
  };

  function reset() {
    setValue("");
    onChange({ description: null, place_id: null });
  }

  function handleKeyDown(e) {
    if (e.keyCode == 13) {
      let suggestion = data[0];

      if (suggestion) {
        handleSelect(suggestion);
      }
    }
  }

  return (
    <div className="relative">
      <input
        type="text"
        className={classNames(
          "block min-h-[46px] w-full rounded-sm border border-gray-300 shadow-sm focus:border-cyan-600 focus:ring focus:ring-cyan-600 focus:ring-opacity-50",
          className,
        )}
        onChange={handleInput}
        disabled={!ready}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        value={value}
      />
      {/* We can use the "status" to decide whether we should display the dropdown or not */}
      {status === "OK" && (
        <div className="inset-top-0 absolute left-0 right-0 z-10 mt-2 rounded border bg-white shadow-small">
          {data.map((suggestion) => (
            <button
              key={suggestion.place_id}
              onClick={() => handleSelect(suggestion)}
              className="block w-full px-2 py-1 text-left hover:bg-gray-100 active:bg-gray-200"
            >
              <span className="text-sm font-medium">
                {suggestion.structured_formatting.main_text}
              </span>{" "}
              <span className="text-xs">
                {suggestion.structured_formatting.secondary_text}
              </span>
            </button>
          ))}
          <div className="flex justify-end p-2">
            <img
              alt="Powered by Google"
              style={{ height: 18 }}
              src="/images/google_on_white.png"
            />
          </div>
        </div>
      )}
      {defaultValue || value ? (
        <div className="absolute top-0 bottom-0 right-0 m-px flex items-center bg-white bg-opacity-90 px-2">
          <button
            onClick={reset}
            className="p-1 text-typo-inactive hover:text-gray-700"
          >
            <X size={16} />
          </button>
        </div>
      ) : null}
    </div>
  );
}
